import React from 'react';
import { APP_NAME } from '@apps/config';
import SignUpScreen from '@apps/screens/SignUp';
import Head from 'next/head';
// import useTranslation from 'next-translate/useTranslation';

const RegisterPage: React.FC = () => {
  // const { t } = useTranslation('screen');

  return (
    <>
      <Head>
        <title>{`Sign Up - ${APP_NAME}`}</title>
      </Head>
      <SignUpScreen />
    </>
  );
};

export default RegisterPage;
